class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tabsWrapper = this;
    this.tabElements = null;
    this.productContent = null;
    this.tabShowAllLists = null;

    this.activateTab = this.activateTab.bind(this);
    this.scrollToTarget = this.scrollToTarget.bind(this);
    this.showAllListItems = this.showAllListItems.bind(this);
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.tabElements = this.querySelectorAll('[data-product-tab]');
    this.productContent = document.querySelector('.product-content');
    this.tabShowAllLists = document.querySelectorAll('.js--list-limit');

    this.tabElements.forEach((tabElement) => {
      tabElement.addEventListener('click', this.activateTab, { signal: this.abortController.signal });
      tabElement.addEventListener('click', this.scrollToTarget, { signal: this.abortController.signal });
    });

    this.tabShowAllLists.forEach((tabShowAllList) => {
      const showMoreBtn = tabShowAllList.querySelector('.js--show-all');

      if (showMoreBtn) {
        showMoreBtn.addEventListener('click', this.showAllListItems, { signal: this.abortController.signal });
      }
    });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  showAllListItems(event) {
    const parent = event.target.closest('.js--list-limit');
    const hiddenListItems = parent.querySelectorAll('div[style="display: none"]');

    hiddenListItems.forEach((listItem) => {
      listItem.style.display = '';
    });

    event.target.style.display = 'none';
  }

  activateTab(event) {
    this.tabElements.forEach((tabElement) => {
      tabElement.classList.remove('product-tabs__tab--active');
    });

    event.target.classList.add('product-tabs__tab--active');
  }

  convertRemToPixels(rem) {
    return parseFloat(rem) * parseFloat(getComputedStyle(document.documentElement).fontSize);
  }

  scrollToTarget(event) {
    const targetElement = document.getElementById(event.target.dataset.productTab);

    if (targetElement !== null) {
      window.scrollTo({
        top: targetElement.offsetTop,
        left: 0,
        behavior: 'smooth',
      });
    }
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}
